import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于全集、免费浏览与快速找片，先看看这里有没有你想要的答案。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950">{item.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                {isOpen ? (
                  <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}